__turbopack_context__.v({
  "name": "AgeCategoryRow-module__4IrDmq__name",
  "nameLine": "AgeCategoryRow-module__4IrDmq__nameLine",
  "nameTagSuffix": "AgeCategoryRow-module__4IrDmq__nameTagSuffix",
  "row": "AgeCategoryRow-module__4IrDmq__row" + " " + __turbopack_context__.i(917291)["lbRadialStroke"] + " " + __turbopack_context__.i(917291)["lbStrokeCard"] + " " + __turbopack_context__.i(917291)["lbCardBlur"] + " " + __turbopack_context__.i(917291)["lbCardBg"],
  "score": "AgeCategoryRow-module__4IrDmq__score" + " " + __turbopack_context__.i(917291)["geistMonoNumbers"],
  "tagSeparator": "AgeCategoryRow-module__4IrDmq__tagSeparator",
});
